module.exports = __webpack_public_path__ + "img/201800-1.7dc76660.jpeg";